module.exports = __webpack_public_path__ + "static/media/6Anniversary.7d3b6b4c.png";